import React from 'react';
import { observer } from 'mobx-react-lite';
import { ResidentMenu } from 'src/components/tenant/ResidentMenu';
export const ActionsCell = observer(_ref => {
  var _params$row;
  let buildingId = _ref.buildingId,
    params = _ref.params,
    propertyId = _ref.propertyId,
    openTenantModal = _ref.openTenantModal,
    setMmodalTempData = _ref.setMmodalTempData;
  return /*#__PURE__*/React.createElement(ResidentMenu, {
    params: params,
    buildingId: buildingId,
    propertyId: propertyId,
    accountId: params.row.accountId,
    openTenantModal: openTenantModal,
    residencyId: params.row.residencyId,
    setMmodalTempData: setMmodalTempData,
    isNotVacant: !params.row.vacant && !((_params$row = params.row) !== null && _params$row !== void 0 && _params$row.isEnrolmentScheduled)
  });
});